import React from "react";
import Card from "react-bootstrap/Card";
import { ImDroplet, ImPointRight } from "react-icons/im";

function ProjectCards(props) {
  const listItems = props.description.map((des) =>
    <li className="about-activity">
      <ImDroplet /> {des}
    </li>
  );
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Subtitle><span className="purple">{props.period}</span></Card.Subtitle>
        <Card.Text style={{ textAlign: "justify" }}>
          <ul>{listItems}</ul>
        </Card.Text>
        
        {"\n"}
        {"\n"}

    
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
